export default __webpack_public_path__ + "static/media/Orders.e0b27ae7.svg";